import {faq} from "./parts/faq.js";
import {contactForms} from "./parts/contact-forms.js";
import {footer} from "./parts/footer.js";
import {clean} from "./parts/clean.js";
import {productHero} from "./parts/product-hero/product-hero.js";

export const sections = ()=> {
    productHero();

    clean();

    faq();

    contactForms();


    footer();
}